import Main from './DataProcessTreatmentMain'
import Manage from './DataProcessTreatmentManage'

export default {
  Main,
  Manage,
}
